import { toHHmmss } from './time-utils';

/**
 * Checks if a user is a demo user based on their email domain
 * @param username - The username/email to check
 * @returns true if the username contains '@pattersondental.com', '@pattersoncompanies.com', or '@demoweave.com', false otherwise
 */
export const isDemoUser = (username?: string): boolean => {
  if (!username) return false;
  const lowercaseUsername = username.toLowerCase();
  return (
    lowercaseUsername.includes('@pattersondental.com') ||
    lowercaseUsername.includes('@pattersoncompanies.com') ||
    lowercaseUsername.includes('@demoweave.com')
  );
};

/**
 * To get the enum key from the value
 */
export const getEnumKeyByValue = <T extends Record<string, number | string | undefined>>(
  enumObject: T,
  value?: number | string
): string => {
  if (value) {
    for (const key in enumObject) {
      if (enumObject[key] === value || enumObject[key] === parseInt(value as string)) {
        return key;
      }
    }
  }
  return '';
};

export const parseTranscript = (transcript: string, tokens?: Record<string, string | undefined>) => {
  const regex = /\[(.*?)\] <(.*?) --> (.*?)> (.+?)\n/g;
  const result = [];
  let match;

  while ((match = regex.exec(transcript)) !== null) {
    const time = {
      start: toHHmmss(parseFloat(match[2] || '0'), true),
      end: toHHmmss(parseFloat(match[3] || '0'), true),
    };
    const speaker = match[1];
    const text = match[4];

    result.push({ time, speaker, text: !tokens ? text : parseTranscriptWithTokens(text ?? '', tokens) });
  }

  return result;
};

export const parseTranscriptWithTokens = (transcript: string, tokens: Record<string, string | undefined>): string => {
  if (!transcript) {
    return '';
  }
  return transcript.replace(/\[([^\]]+)\]/g, (match, p1) => tokens[p1] || match);
};

export const findCitationInTranscript = ({
  citation,
  transcript,
}: {
  citation: string;
  transcript: string;
}): { start: number; end: number; isFound: boolean } => {
  const startIndex = transcript.toLowerCase().indexOf(citation.toLowerCase());
  const endIndex = startIndex === -1 ? -1 : startIndex + citation.length;
  return { start: startIndex, end: endIndex, isFound: startIndex !== -1 };
};
